import store from '~/store';

const getMetadata = slug => store.getState().bootstrap.metadata.find(metadata => metadata.slug === slug);
const getMetadataName = slug => getMetadata(slug)?.name || slug;

const getDeviceMetadata = (equipment, rootDevice) => {
    if (!equipment || !rootDevice) {
        return [];
    }

    const keys = [];

    if (equipment.equipment_category_slug === 'mbus') {
        keys.push('mbus_id');
    } else if (['mbus_tcp_rtu', 'modbus_tcp_rtu'].includes(equipment.equipment_category_slug)) {
        keys.push('ip');
    } else if (['modbus_bridge', 'modbus_digital', 'modbus_rtu'].includes(equipment.equipment_category_slug)) {
        keys.push('modbus_id');
    } else if (equipment.equipment_category_slug === 'one_wire') {
        keys.push('one_wire_id');
        if (rootDevice.equipment_category_slug === 'old_wise_box') {
            keys.push('old_one_wire_id', 'range_max_degrees', 'range_min_degrees', 'resolution_bits', 'step_degrees');
        }
    }

    if (equipment.equipment_type_slug === 'electricity_meter') {
        keys.push('ti_current', 'ti_type');
    }

    return keys.map(key => getMetadata(key));
};

const getEquipmentMetadata = _equipmentCategory => [];

const getMeasurementMetadata = (device, rootDevice) => {
    if (!device || !rootDevice) {
        return [];
    }

    const keys = [];

    if (device.equipment_category_slug === 'digital_meter') {
        keys.push('ratio');
    } else if (device.equipment_category_slug === 'modbus_bridge') {
        keys.push('little_endian', 'max_value', 'min_value', 'modbus_memory_address', 'modbus_numerical_format', 'modbus_package_inversion', 'modbus_protocol_method', 'ratio');
    } else if (device.equipment_category_slug === 'wise_current' && rootDevice.equipment_category_slug === 'old_wise_box') {
        keys.push('ct_calibrated_resistor', 'ct_nominal_current', 'ct_turn_ratio', 'ct_type');
    } else if (device.equipment_category_slug === 'wise_current' && rootDevice.equipment_category_slug === 'new_wise_box') {
        keys.push('ti_current_range', 'ti_voltage_range');
    } else if (device.equipment_category_slug === 'wise_input') {
        keys.push('input_kind', 'inverted');
    } else if (device.equipment_category_slug === 'wise_output' && rootDevice.equipment_category_slug === 'old_wise_box') {
        keys.push('normally_closed');
    } else if (device.equipment_type_slug === 'input_sensor') {
        keys.push('inverted');
    }

    return keys.map(key => getMetadata(key));
};
const getReadingMetadata = equipment => {
    if (!equipment) {
        return [];
    }

    const keys = [];

    if (equipment.equipment_category_slug === 'one_wire') {
        keys.push('max_value', 'min_value');
    } else if (equipment.equipment_category_slug === 'mbus') {
        keys.push('mbus_port_id', 'max_value', 'min_value', 'ratio');
    } else if (equipment.equipment_category_slug === 'wise_output') {
        keys.push('old_wise_output_id', 'old_wise_output_port_number', 'port_number');
    } else if (['wise_current', 'wise_input'].includes(equipment.equipment_category_slug)) {
        keys.push('arduino_number', 'port_number');
    } else if (equipment.equipment_category_slug === 'modbus_rtu') {
        keys.push('little_endian', 'max_value', 'min_value', 'modbus_memory_address', 'modbus_numerical_format', 'modbus_package_inversion', 'modbus_protocol_method', 'ratio');
    } else if (equipment.equipment_category_slug === 'modbus_digital') {
        keys.push('little_endian', 'max_value', 'min_value', 'modbus_memory_address', 'modbus_numerical_format', 'modbus_package_inversion', 'modbus_protocol_method');
    }

    return keys.map(key => getMetadata(key));
};

export {
    getDeviceMetadata,
    getEquipmentMetadata,
    getMeasurementMetadata,
    getMetadataName,
    getReadingMetadata
};
